import { render, staticRenderFns } from "./VInputFile.vue?vue&type=template&id=cc1bc50c"
import script from "./VInputFile.vue?vue&type=script&lang=js"
export * from "./VInputFile.vue?vue&type=script&lang=js"
import style0 from "./VInputFile.vue?vue&type=style&index=0&id=cc1bc50c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports